import { Image, ImageProps } from '@makyoapp/makyo-tw-ui'

export type CompImageProps = ImageProps

export const CompImageCore = Image
